module.exports = __webpack_public_path__ + "img/category_lighting.33340889.jpg";